import { useApi } from "@lending/lib/api";

const noop = () => Promise.resolve();

interface Props {
  onSuccess?: () => void | Promise<void>;
  onError: (error: Record<string, string[]>) => void;
}

function useEvaluateAutoLoanApplicationQuery({ onSuccess = noop, onError }: Props) {
  const $api = useApi();

  return $api.useMutation("post", "/v2/lending/vehicle_loan_applications/{uuid}/evaluate/", {
    onSuccess,
    onError,
  });
}

export { useEvaluateAutoLoanApplicationQuery };
